const toggler = document.querySelector('.nav-toggle');
if (toggler) {
    toggler.addEventListener('click', () => {
        [].forEach.call(document.querySelectorAll('html'), (el: any) => {
            el.classList.toggle('nav-open');
        });
    });
}

const togglerClose = document.querySelector('.nav-toggle-close');
if (togglerClose) {
    togglerClose.addEventListener('click', () => {
        [].forEach.call(document.querySelectorAll('html'), (el: any) => {
            el.classList.remove('nav-open');
        });
    });
}

const backface = document.querySelector('.backface-nav');
if (backface) {
    backface.addEventListener('click', () => {
        [].forEach.call(document.querySelectorAll('html'), (el: any) => {
            el.classList.remove('nav-open');
        });
    });
}